




















import { Component, Prop, Vue } from 'vue-property-decorator';
import Icon from '@/components/Icon.vue';

@Component({
  components: {
    Icon,
  },
})
export default class MobileMenu extends Vue {
  @Prop() loading: boolean;
  @Prop() header: string;

  scrolledDown: boolean = false;

  handleClose() {
    this.$emit('close');
  }

  handleEscape(e: KeyboardEvent) {
    if (e.key !== 'Escape') {
      return;
    }
    this.handleClose();
  }

  get scrollClass(): string {
    return this.scrolledDown ? 'scrolled-down' : 'scrolled-top';
  }

  handleScrollEvent(event: any) {
    const modalBody: Element = event.currentTarget;
    if (!this.scrolledDown && !!modalBody.scrollTop) {
      this.scrolledDown = true;
    } else if (this.scrolledDown && !modalBody.scrollTop) {
      this.scrolledDown = false;
    }
  }

  mounted() {
    window.addEventListener('keyup', this.handleEscape);
  }
}
